<template>
    <div class="top-line search-line">
        <span class="sk-title-small content-center" style="flex: 1">{{ title }}</span>
    </div>
    <div class="split-line"></div>
    <div class="top-line search-line">
        <div class="right">
            <SelectEntityIcon @select="onSelectedEntity"></SelectEntityIcon>
        </div>
        <div class="left">
            <input type="button" :class="getButtonClass(1)" @click="changeType(1)" value="日报" />
            <input type="button" :class="getButtonClass(2)" @click="changeType(2)" value="周报" />
            <input type="button" :class="getButtonClass(3)" @click="changeType(3)" value="月报" />
            <input type="button" :class="getButtonClass(4)" @click="changeType(4)" value="年报" />
            <input type="button" :class="getButtonClass(5)" @click="changeType(5)" value="自定义" />
            <el-date-picker v-model="date" v-if="type == 1" size="small" type="date" placeholder="选择日期"> </el-date-picker>
            <el-date-picker
                v-model="date"
                v-if="type == 2"
                @change="changedWeek"
                size="small"
                type="week"
                format="gggg 第 ww 周"
                placeholder="选择周"
            >
            </el-date-picker>
            <el-date-picker v-model="date" v-if="type == 3" size="small" type="month" placeholder="选择月"> </el-date-picker>
            <el-date-picker v-model="date" v-if="type == 4" size="small" type="year" placeholder="选择年"> </el-date-picker>
            <el-date-picker v-model="dates" v-if="type == 5" type="daterange" size="small" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
        </div>
        <div class="right">
            <input type="button" class="button-ok block-button" value="确定" @click="onSearch" />
            <input type="button" class="button-normal" value="重置" @click="initData" />
        </div>
    </div>
</template>
<script>
import SelectEntityIcon from "../../components/SelectEntityIcon.vue";
export default {
    name: "SearchLine",
    props: {
        entitys: { type: Array },
    },
    components: { SelectEntityIcon },
    data() {
        return {
            isShowDialog: false,
            entityID: "",
            title: "",
            date: "",
            date1: "",
            date2: "",
            dates: [],
            type: 1,
        };
    },
    created() {
        this.initData();
    },
    mounted() {
        this.onSearch();
    },
    methods: {
        initData() {
            this.date = new Date().format("yyyy-MM-dd");
            this.dates = [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()];
            if (this.entitys && this.entitys.length > 0) {
                this.entityID = this.entitys[0].EntityID;
            }
            this.type = 1;
        },
        changedWeek(a, b, c) {
            console.log(a);
            console.log(b);
            console.log(c);
        },
        onSelectedEntity(data) {
            this.entityID = data.EntityID;
            this.changeTitle(data.EntityName);
        },
        onSearch() {
            if (this.type == 5) {
                this.date1 = new Date(this.dates[0]).format("yyyy-MM-dd");
                this.date2 = new Date(this.dates[1]).format("yyyy-MM-dd");
            } else {
                this.date1 = new Date(this.date).format("yyyy-MM-dd");
                this.date2 = "";
            }
            let data = {
                Type: this.type,
                BeginTime: this.date1,
                EndTime: this.date2,
                ID: this.entityID,
                IDType: 2,
            };
            this.$emit("search", data);
        },
        changeTitle(v) {
            let name = v;
            name += "客流综合数据统计";
            this.title = name;
        },
        getButtonClass(tp) {
            if (tp == this.type) {
                return "block-button button-report";
            }
            return "block-button button-normal";
        },
        changeType(tp) {
            this.type = tp;
        },
        showDialog() {
            this.isShowDialog = true;
        },
    },
};
</script>
<style scoped>
.block-button {
    margin-right: 10px;
}
</style>
